var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-textarea',{staticStyle:{"border-radius":"10px"},attrs:{"solo":"","name":"input-7-4","outlined":"","value":_vm.model},on:{"input":_vm.setModelData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }